import React, { useEffect, useRef } from 'react'
import Layout from '../common/Layout'
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from 'react-hook-form';
import ApiHelper from '../../helperFunction/ApiHelper';
import API_ENDPOINTS from '../../helperFunction/Constant';
import { Toast } from 'primereact/toast';
import { Link, useNavigate, useParams } from 'react-router-dom';

const FaqsAddEdit = () => {

    const { id } = useParams()
    const isEdit = id ? true : false

    const toast = useRef(null)
    const navigate = useNavigate()

    const schema = yup.object({
        question: yup.string().required("Questions is required"),
        answer: yup.string().required("Answers is required"),
        faqType: yup.string(),
        isActive: yup.boolean(),
    });

    const { register, handleSubmit, reset, formState: { errors }, } = useForm({ resolver: yupResolver(schema), });

    const resetValue = () => {
        reset({
            questions: '',
            answers: '',
            isActive: '',
        })
    }

    useEffect(() => {
        isEdit && getFaqs()
    }, [])

    const getFaqs = () => {
        ApiHelper.get(`${API_ENDPOINTS.FAQS}/${id}`).then((res) => {
            if (res.status === 200) {
                reset({
                    question: res.data.data.question,
                    answer: res.data.data.answer,
                    faqType: res.data.data.faqType,
                    isActive: res.data.data.isActive,
                })
            }
        }).catch((error) => {
            console.log("Error: ", error);
        })
    }

    const onSubmit = (data) => {
        if (isEdit) {
            update(data)
        } else {
            add(data)
        }
    };

    const add = (data) => {
        ApiHelper.post(`${API_ENDPOINTS.FAQS}/`, data).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 })
                setTimeout(() => {
                    navigate('/faqs')
                }, 1500)
            }
        }).catch((error) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.response.data.message, life: 3000 })
        })
    };
    const update = (data) => {
        ApiHelper.put(`${API_ENDPOINTS.FAQS}/${id}`, data).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 })
                setTimeout(() => {
                    navigate('/faqs')
                }, 1500)
            }
        }).catch((error) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.response.data.message, life: 3000 })
        })
    };

    return (
        <>
            <Toast ref={toast} />
            <Layout>
                <div class="content-wrapper">
                    <div class="container-xxl flex-grow-1 container-p-y">
                        <div class="d-flex justify-content-between align-items-center py-3">
                            <h4 class="fw-bold py-3 mb-2">
                                <span class="d-flex text-muted fw-light"> 
                                    <p class="breadcrumb-item pageHeader active me-2 mb-0" aria-current="page" onClick={() => navigate('/faqs')}> FAQS </p> / <b className='mx-2'> {isEdit ? 'Edit' : "Add"} </b>
                                </span>
                            </h4>
                            <Link to="/faqs" class="btn btn-secondary">⬅ Go Back</Link>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="card mb-4">
                                    <div class="card-body">
                                        <form onSubmit={handleSubmit(onSubmit)}>
                                            <div class="row mb-3">
                                                <div class="col-md-3">
                                                    <label class="form-label">Question</label>
                                                    <input type="text" name="question" class="form-control" {...register("question")} />
                                                    <small className="text-danger">{errors.question?.message}</small>
                                                </div>
                                                <div class="col-md-9 mb-4">
                                                    <label class="form-label">Answer</label>
                                                    <textarea rows="3" type="text" name="answer" class="form-control" {...register("answer")} />
                                                    <small className="text-danger">{errors.answer?.message}</small>
                                                </div>
                                                <div class="col-md-3 mb-3">
                                                    <label class="form-label">Faq Type</label>
                                                    <select name="faqType" class="form-select" {...register("faqType")} >
                                                        <option selected value="HOME_PAGE_FAQ">HOME_PAGE_FAQ</option>
                                                        <option value="COURSE_DETAIL_PAGE_FAQ">COURSE_DETAIL_PAGE_FAQ</option>
                                                    </select>
                                                </div>
                                                <div class="col-md-3">
                                                    <label class="form-label">Status</label>
                                                    <div class="form-check form-switch mb-2">
                                                        <input class="form-check-input mt-2" name="isActive" type="checkbox" id="flexSwitchCheckDefault" {...register("isActive")} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="mt-4">
                                                <button type="submit" class="btn btn-primary me-3">Save</button>
                                                <button type="button" onClick={() => resetValue()} class="btn btn-secondary reset-btn">Reset</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    )
}

export default FaqsAddEdit
